import { render } from "./Approve75Liquidations.vue?vue&type=template&id=71700bb0"
import script from "./Approve75Liquidations.vue?vue&type=script&lang=js"
export * from "./Approve75Liquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__